import { createComponent } from '../lib';
import { VmControl } from '@vime/core';
import { define } from '../lib';
define('vm-control', VmControl);
;
export default createComponent('vm-control', new Set(['keys', 'identifier', 'hidden', 'label', 'menu', 'expanded', 'pressed', 'isTouch']));
//# sourceMappingURL=Control.jsx.map